import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from 'react-router-dom';

Sentry.init({
    dsn: 'https://0833c679228306ae4d22f4d21e3722f0@o4507407638462464.ingest.de.sentry.io/4507407642787920',
    integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
        // Sentry.feedbackIntegration({
        //     colorScheme: 'light',
        // }),
        Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
        /^\//,
        /^https:\/\/portal\.cashbuild\.co\.za\//,
        /^https:\/\/portal-api(-qa)?\.cashbuild\.co\.za\//,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});
